<!--用户下拉选择器-->
<template>
    <el-autocomplete
            size="small"
            :disabled="disabled"
            v-model="item.value"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入关键词"
            @select="handleChange"
            @blur="handleBlur"
            clearable
            @clear="handleBlur"
    >
    </el-autocomplete>
</template>


<script>
    import UserService from "~/services/user";
    import {isNumber} from 'util';

    export default {
        name: "UserSelect",
        props: {
            uid: '',//当前选择的uid，
            disabled:false,
            name:''
        },
        data() {
            return {
                uids: null,
                item: {
                    label:'',
                    value:''
                },
                users: []
            };
        },

        created: function () {
            if (typeof this.uid != 'undefined' && this.uid>0) {
                this.uids = this.uid;
                /**
                 * 默认选中
                 */
                if (isNumber(this.uids)) {
                    this.getDefault(this.uids);
                }
            }else{
                this.item.value = this.name;
            }
        },
        watch:{
            uid:function(value){
                if (isNumber(value) && value>0) {
                    this.getDefault(value);
                }else{
                    this.reset();
                }
            }
        },
        methods: {
            querySearchAsync(queryString, cb) {
                let qs = (queryString || '').toString().trim() || undefined;
                let params = {
                    fields: 'id,name',
                    keyword: qs,
                    scenario: 'all-user'
                };
                UserService.getAll(params).then(res => {
                    if (!res.data) return;
                    let results = res.data.filter(item => {
                        if (!qs) return true;
                        return item.name.toString().indexOf(qs) > -1;
                    }).map(item => {
                        return {
                            value: item.name,
                            label: item.id
                        };
                    });
                    cb(results)
                });
            },
            
            getDefault(uid) {
                let params = {
                    fields: 'id,name',
                    id: uid,
                    scenario: 'all-user'
                };
                UserService.getAll(params).then(res => {
                    if (!res.data) return;
                        this.item = {
                            value: res.data[0].name,
                            label: res.data[0].id
                        };
                });
            },

            //select value值变化时触发
            handleChange(item) {
                this.item = item;
                console.log(item);
                this.$emit("change", item);
            },

            handleBlur($event) {
                /**
                 * 鼠标移除事件不需要触发。
                 * 不然会出现我不选择修改值，会造成当前对象为空的想象。
                 */
                this.item.label = '';
                this.$emit("change", this.item);
            },

            //对输入框进行重置
            reset() {
                this.uids = '';
                this.item = {
                    label:'',
                    value:''
                };
            }
        },
    }


</script>


// WEBPACK FOOTER //
// src/widgets/UserSelect.vue